export default {
  subtitle:
    "Dive deep into CBAM compliance, carbon emission calculations, and industry best practices",
  no_posts: "No articles available",
  loading: "Loading...",
  read_time: "{minutes} min read",
  minute: "min",
  share: "Share:",
  back_to_list: "Back to Blog List",
  article_not_found: "Article Not Found",
  article_not_found_desc: "Sorry, the article you are looking for does not exist",
  cta_title: "Ready to start your CBAM compliance journey?",
  cta_subtitle: "Try TaxEcoBit now to easily generate EU-compliant carbon emission reports",
  cta_button: "Try Now",
};
